<template>
  <v-row no-gutters>
    <v-col cols="12">
      <v-list-item>
        <v-list-item-icon v-if="icon">
          <v-icon size="32">{{ icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-subtitle>{{ subtitle }}</v-list-item-subtitle>
          <v-list-item-title>
            <v-select
              v-model="newValue"
              v-bind="currentProperties()"
            />
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-col>
  </v-row>
</template>

<script>
import { ref, watch } from '@vue/composition-api';

export default {
  props: {
    value: {
      type: Array,
      default: null
    },
    dependentValue: {
      type: String,
      default: null
    },
    field: {
      type: Object,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    },
    rules: {
      type: Array,
      default: null
    }
  },
  setup (props, context) {
    const newValue = ref(props.value);

    // v-model
    watch(newValue, () => {
      context.emit('input', newValue.value);
    });

    watch(() => props.value, () => {
      newValue.value = props.value;
    });

    const currentProperties = () => {
      const properties = {};

      // General properties
      properties.rules = props.field.rules;
      properties.placeholder = props.field.label;

      properties.readonly = props.field.readonly;

      properties['menu-props'] = { 'z-index': '500 !important' };
      properties.items = props.field.options[props.dependentValue];
      properties.multiple = props.field.multivalued;

      if (!properties.readonly) {
        properties.clearable = true;
      }

      properties['item-value'] = 'value';
      properties['item-text'] = 'text';
      properties['item-color'] = 'third';
      properties.chips = true;
      properties.persistent = true;
      properties.dense = true;
      properties['hide-details'] = true;
      properties.color = 'black';
      properties.rules = props.rules;

      return properties;
    };

    return { newValue, currentProperties };
  }
};
</script>
